import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { timePeriodSchema } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { GithubService } from '../../service';

export type BranchProtectionRulesLogsConfig = typeof BranchProtectionRulesLogsConfig._.Config;

export const BranchProtectionRulesLogsConfig = IntegrationConfig.make({
  service: GithubService,
  name: Integration_Handler_Names_Enum.BranchProtectionRulesLogs,
  configSchema: z.object({
    repoName: z.string().min(1),
    rulePattern: z.string().min(1),
    filters: z
      .object({
        createdAt: timePeriodSchema.optional(),
      })
      .optional(),
  }),
});
